const React = require('react');

class C18LabeledInput extends React.Component {

  render() {
    return (
      <div style={{ display: 'inline-block'}}>
        <label htmlFor="nameInput" style={{ display: 'block', marginBottom: '0.25rem' }}>
          {this.props.parms.name}
        </label>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type={this.props.parms.type||"text"}
            id="nameInput"
            value={this.props.parms.value}
            onChange={(e) => this.props.parms.onChange(e)}
            style={{ padding: '0.5rem', width: '125px' }}
          />
          <span>{this.props.parms.unit||""}</span>
        </div>
      </div>
    );
  }
}

export default C18LabeledInput;

